import { apiClient } from './api';
import type {
  RotationalConfig,
  RotationalConfigResponse,
  RotationalConfigAllResponse,
  SaveRotationalConfigInput,
  AdvanceRotationResponse,
} from './types';

export class RotationalTrainingService {
  private static readonly BASE = '/api/rotational-training';

  static async getAll(programId: number): Promise<RotationalConfigAllResponse> {
    const response = await apiClient.get<RotationalConfigAllResponse>(
      `${this.BASE}/${programId}/all`
    );
    return response.data;
  }

  static async get(programId: number, dayNumber: number): Promise<RotationalConfigResponse> {
    const response = await apiClient.get<RotationalConfigResponse>(
      `${this.BASE}/${programId}/${dayNumber}`
    );
    return response.data;
  }

  static async save(
    programId: number,
    dayNumber: number,
    input: SaveRotationalConfigInput
  ): Promise<{ message: string; config: RotationalConfig }> {
    const response = await apiClient.post<{ message: string; config: RotationalConfig }>(
      `${this.BASE}/${programId}/${dayNumber}`,
      input
    );
    return response.data;
  }

  static async delete(programId: number, dayNumber: number): Promise<void> {
    await apiClient.delete(`${this.BASE}/${programId}/${dayNumber}`);
  }

  static async advance(programId: number, dayNumber: number): Promise<AdvanceRotationResponse> {
    const response = await apiClient.post<AdvanceRotationResponse>(
      `${this.BASE}/${programId}/${dayNumber}/advance`
    );
    return response.data;
  }

  static async setIndex(
    programId: number,
    dayNumber: number,
    index: number
  ): Promise<{ message: string; config: RotationalConfig }> {
    const response = await apiClient.post<{ message: string; config: RotationalConfig }>(
      `${this.BASE}/${programId}/${dayNumber}/set-index`,
      { index }
    );
    return response.data;
  }
}

export default RotationalTrainingService;
